export default "__VITE_ASSET__DmvtLKff__"